import theme from '../../../../../lib/theme';

const {
  layouts,
  scale,
  layers,
  corners,
  media,
  colors,
  font: {
    families,
    spacings,
    heights,

    ...font
  },
} = theme;
export default () => ({
  top: {
    ...layouts.column,

    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '70vh',
  },

  background: {
    zIndex: layers.mid,
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `linear-gradient(317.84deg, rgba(158,66,255,0.3) 0%, rgba(101,31,255,0.75) 100%), url('https://images.startsat60.com/wp-content/uploads/20200320163705/Untitled-design-3-1.jpg')`,
  },

  tagline: {
    display: 'none',

    [media.xs.up]: {
      display: 'block',
    },
  },

  inner: {
    position: 'relative',
    maxWidth: 660,
    width: '100%',
  },

  foreground: {
    ...layouts.column,

    alignItems: 'center',
    justifyContent: 'center',
    zIndex: layers.high,
    padding: `${scale.m} ${scale.xs} ${scale.l}`,

    [media.s.up]: {
      padding: `${scale.l} ${scale.s}`,
    },
  },

  startTop: {
    zIndex: layers.high,
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translate(-50%, 50%)',
    height: 60,
    padding: `0 ${scale.m}`,
    fontSize: font.xl,
    lineHeight: heights.xl,
  },

  startBottom: {
    height: 60,
    padding: `0 ${scale.m}`,
    fontSize: font.xl,
    lineHeight: heights.xl,
  },

  video: {
    minWidth: 'calc(16 / 9 * 50vh)',
    width: '100%',
  },

  scrim: {
    textShadow: `0px 0px ${scale.xxxs} rgba(0, 0, 0, 0.5)`,
  },

  bottom: {
    ...layouts.column,

    position: 'relative',
    zIndex: layers.mid,
    backgroundColor: '#ffeffa',
    alignItems: 'center',
    padding: `${scale.l} ${scale.xs}`,

    [media.s.up]: {
      padding: `${scale.l} ${scale.s}`,
    },
  },

  navigationCards: {
    ...layouts.row,

    flexWrap: 'wrap',
    justifyContent: 'center',
  },

  navigationCard: {
    ...layouts.column,

    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 150,
    overflow: 'hidden',
    margin: scale.xxs,
    backgroundColor: colors.white,
    borderRadius: corners.m,
    border: `1px solid ${colors.grey}`,
    padding: scale.xs,
    textDecoration: 'none',
    textAlign: 'center',
    color: colors.black,
    transition: 'background-color 150ms linear',

    [media.xs.up]: {
      width: 150,
    },

    '&:hover': {
      backgroundColor: colors.light_grey,
    },
  },

  navigationCardTitle: {
    marginTop: scale.xxxs,
    fontSize: font.s,
    lineHeight: heights.s,
    fontFamily: families.primary,
    letterSpacing: spacings.m,
  },

  valuePropositions: {
    ...layouts.column,

    [media.m.up]: {
      ...layouts.row,

      alignItems: 'center',
      justifyContent: 'space-between',
    },
  },

  valueProposition: {
    margin: scale.xs,
    flex: '1 0',
  },

  partnerContainer: {
    ...layouts.spacedColumn('m'),

    borderBottom: `2px solid ${colors.grey}`,
    alignItems: 'center',
    padding: `${scale.m} ${scale.xs}`,
  },

  partners: {
    ...layouts.container('l'),
    ...layouts.row,

    '& > *': {
      ...layouts.column,

      justifyContent: 'center',
      alignItems: 'center',
      margin: scale.m,
      height: 100,
      width: 200,
    },

    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
});
